export const FormControlConstants = {
	formControlTypes: {
		addressAutocomplete: 'addressAutocomplete',
		bodyStructureControlArray: 'bodyStructureControlArray',
		buttonGroup: 'buttonGroup',
		checkbox: 'checkbox',
		checkboxGroup: 'checkboxGroup',
		checkboxOneOrZero: 'checkboxOneOrZero',
		container: 'container',
		custom: 'custom',
		dashTextbox: 'dashTextbox',
		date: 'date',
		datePicker: 'datePicker',
		dateTime: 'dateTime',
		dateWithClear: 'dateWithClear',
		fileUpload: 'fileUpload',
		findings: 'findings',
		findingSites: 'findingSites',
		horizontalRadioGroup: 'horizontalRadioGroup',
		html: 'html',
		image: 'image',
		label: 'label',
		multiselect: 'multiselect',
		radioGroup: 'radioGroup',
		searchAutocomplete: 'searchAutocomplete',
		select: 'select',
		selectWithOther: 'selectWithOther',
		subtitle: 'subtitle',
		switch: 'switch',
		text: 'text',
		textArea: 'textArea',
		textBox: 'textbox',
		textBoxCalculatd: 'textboxCalculated',
		textBoxArray: 'textboxArray',
		time: 'time',
		title: 'title',
		warning: 'warning',
		yesNo: 'yesNo',
		yesNoNa: 'yesNoNa',
	},
	suggestionTypes: {
		answer: 'answer',
		diagnosis: 'diagnosis',
	},
	reservedFieldNames: {
		stayFindings: 'stayFindings',
		visitFindings: 'visitFindings',
		diagnosesCodes: 'diagonsesCodes',
		events: 'events',
	},
	validationRules: {
		doesNotContainAtSameTime: 'doesNotContainAtSameTime',
		doesNotEqual: 'doesNotEqual',
		doesNotStartWith: 'doesNotStartWith',
		equals: 'equals',
		expression: 'expression',
		greaterThan: 'greaterThan',
		greaterThanOrEqualTo: 'greaterThanOrEqualTo',
		isFalse: 'isFalse',
		isTrue: 'isTrue',
		lessThan: 'lessThan',
		lessThanOrEqualTo: 'lessThanOrEqualTo',
		matches: 'matches',
		maxLength: 'maxLength',
		mustBeEmpty: 'mustBeEmpty',
		mustBeOnlySelectedValue: 'mustBeOnlySelectedValue',
		required: 'required',
	},
	whenOperations: {
		changes: 'changes',
		contains: 'contains',
		doesNotContain: 'doesNotContain',
		doesNotEqual: 'doesNotEqual',
		equals: 'equals',
		expression: 'expression',
		isEmpty: 'isEmpty',
		isFalse: 'isFalse',
		isLongerThan: 'isLongerThan',
		isNotEmpty: 'isNotEmpty',
		isTrue: 'isTrue',
	},
	formControlDataTypes: {
		boolean: 'boolean',
		complex: 'complex',
		date: 'date',
		dateTime: 'dateTime',
		decimal: 'decimal',
		integer: 'integer',
		objectArray: 'objectArray',
		string: 'string',
		stringArray: 'stringArray',
		time: 'time',
	},
	formValueUnits: {
		grams: 'grams',
		calories: 'calories',
		ounces: 'ounces',
		degreesF: 'degrees-f',
		percent: 'percent',
		perMin: '/min',
		mmHg: 'mmHg',
		lbs: 'lbs',
		in: 'in',
	},
	formValidationOperators: {
		or: '|',
		and: '&',
		evalValueEscape: '@',
	},
	whenConditionOperators: {
		or: 'or',
		and: 'and',
	},
	formFieldActionTypes: {
		clear: 'clear',
		copy: 'copy',
		reset: 'reset',
		resetIfEquals: 'resetIfEquals',
		set: 'set',
	},
};


export const FormControlTypes = [
	'addressAutocomplete',
	'bodyStructureControlArray',
	'buttonGroup',
	'checkbox',
	'checkboxGroup',
	'checkboxOneOrZero',
	'container',
	'custom',
	'dashTextbox',
	'date',
	'datePicker',
	'dateTime',
	'dateWithClear',
	'fileUpload',
	'findings',
	'findingSites',
	'horizontalRadioGroup',
	'html',
	'image',
	'label',
	'multiselect',
	'radioGroup',
	'searchAutocomplete',
	'select',
	'selectWithOther',
	'subtitle',
	'switch',
	'text',
	'textArea',
	'textbox',
	'textboxCalculated',
	'textboxArray',
	'time',
	'title',
	'warning',
	'yesNo',
	'yesNoNa'
 ] as const;

export type FormControlType = typeof FormControlTypes[number];

export function isFormControlType(formControlTypeKey: string): formControlTypeKey is FormControlType {
	return FormControlTypes.includes(formControlTypeKey as FormControlType);
}

export const ValidationRules = [
	'doesNotContainAtSameTime',
	'doesNotEqual',
	'doesNotStartWith',
	'equals',
	'expression',
	'greaterThan',
	'greaterThanOrEqualTo',
	'isFalse',
	'isTrue',
	'lessThan',
	'lessThanOrEqualTo',
	'matches',
	'maxLength',
	'mustBeEmpty',
	'mustBeOnlySelectedValue',
	'required'
 ] as const;

export type ValidationRule = typeof ValidationRules[number];

export function isValidationRule(validationRule: string): validationRule is ValidationRule {
	return ValidationRules.includes(validationRule as ValidationRule);
}

export const WhenOperations = [
	'changes',
	'contains',
	'doesNotContain',
	'doesNotEqual',
	'equals',
	'expression',
	'isEmpty',
	'isFalse',
	'isLongerThan',
	'isNotEmpty',
	'isTrue'
 ] as const;

export type WhenOperation = typeof WhenOperations[number];

export function isWhenOperation(whenOperation: string): whenOperation is WhenOperation {
	return WhenOperations.includes(whenOperation as WhenOperation);
}

export const FormControlDataTypes = [
	'boolean',
	'complex',
	'date',
	'dateTime',
	'decimal',
	'integer',
	'objectArray',
	'string',
	'stringArray',
	'time'
 ] as const;

export type FormControlDataType = typeof FormControlDataTypes[number];

export function isFormControlDataType(formControlDataTypeKey: string): formControlDataTypeKey is FormControlDataType {
	return FormControlDataTypes.includes(formControlDataTypeKey as FormControlDataType);
}